import "core-js/modules/es.number.constructor.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import PricePostedUsaModificationPopover from "@/components/price-posting/usa-pro/PricePostedUsaModificationPopover.vue";
export default {
  name: "WineDiscountPricePostedEditModalColumn",
  props: {
    item: Object,
    threshold: Number,
    editingDiscountPrice: Object,
    isAnyFormConfiguring: Boolean,
    isAnyActionInProgress: Boolean,
    startDiscountPriceEditMode: Function,
    resetDiscountPriceEditMode: Function,
    saveDiscountPrice: Function,
    addingDiscountPriceObject: Object,
    startDiscountPriceAddMode: Function,
    resetDiscountPriceAddMode: Function,
    addWineDiscountPrice: Function,
    confirmDeleteDiscountPrice: Function
  },
  components: {
    PricePostedUsaModificationPopover: PricePostedUsaModificationPopover
  },
  data: function data() {
    return {
      formRules: formRules,
      filterDecimal2digitsKey: filterDecimal2digitsKey
    };
  },
  computed: {
    discount: function discount() {
      return this.item["priceDiscount".concat(this.threshold)];
    }
  },
  methods: {
    startEdit: function startEdit() {
      this.startDiscountPriceEditMode(this.item, this.threshold);
    },
    cancelEdit: function cancelEdit() {
      this.resetDiscountPriceEditMode(this.item, this.threshold);
    },
    saveEdit: function saveEdit() {
      this.saveDiscountPrice(this.item, this.threshold);
    },
    startAdd: function startAdd() {
      this.startDiscountPriceAddMode(this.item, this.threshold);
    },
    cancelAdd: function cancelAdd() {
      this.resetDiscountPriceAddMode();
    },
    saveAdd: function saveAdd() {
      this.addWineDiscountPrice();
    },
    confirmDelete: function confirmDelete() {
      this.confirmDeleteDiscountPrice(this.item, this.threshold);
    }
  }
};